import { MAX_PIVOT_ROWS } from "helpers/ai"
import { ERROR_CODES } from "./constants"

export function getErrorMessage(error) {
  switch (error?.code) {
    case ERROR_CODES.CHAT_CONTINUE_THREAD_WITH_MESSAGE_CONFLICT:
      return "The message you sent is out of sync with the current thread. Please refresh the thread and try again."
    default:
      return "Oops! Something went wrong on my end. Please try again."
  }
}

export function isPivotable(key, records = []) {
  return !key.toLowerCase().includes("date")
    && !key.toLowerCase().includes("time")
    && records
    && new Set(records.map(record => record[key])).size <= MAX_PIVOT_ROWS
}
